export default "__VITE_ASSET__DW$pgX4U__"